var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9375 8.75C25.9375 8.99864 25.8387 9.2371 25.6629 9.41291C25.4871 9.58873 25.2486 9.6875 25 9.6875H5C4.75136 9.6875 4.5129 9.58873 4.33709 9.41291C4.16127 9.2371 4.0625 8.99864 4.0625 8.75C4.0625 8.50136 4.16127 8.2629 4.33709 8.08709C4.5129 7.91127 4.75136 7.8125 5 7.8125H25C25.2486 7.8125 25.4871 7.91127 25.6629 8.08709C25.8387 8.2629 25.9375 8.50136 25.9375 8.75ZM25.9375 15C25.9375 15.2486 25.8387 15.4871 25.6629 15.6629C25.4871 15.8387 25.2486 15.9375 25 15.9375H5C4.75136 15.9375 4.5129 15.8387 4.33709 15.6629C4.16127 15.4871 4.0625 15.2486 4.0625 15C4.0625 14.7514 4.16127 14.5129 4.33709 14.3371C4.5129 14.1613 4.75136 14.0625 5 14.0625H25C25.2486 14.0625 25.4871 14.1613 25.6629 14.3371C25.8387 14.5129 25.9375 14.7514 25.9375 15ZM25.9375 21.25C25.9375 21.4986 25.8387 21.7371 25.6629 21.9129C25.4871 22.0887 25.2486 22.1875 25 22.1875H5C4.75136 22.1875 4.5129 22.0887 4.33709 21.9129C4.16127 21.7371 4.0625 21.4986 4.0625 21.25C4.0625 21.0014 4.16127 20.7629 4.33709 20.5871C4.5129 20.4113 4.75136 20.3125 5 20.3125H25C25.2486 20.3125 25.4871 20.4113 25.6629 20.5871C25.8387 20.7629 25.9375 21.0014 25.9375 21.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuIcon);
export default __webpack_public_path__ + "static/media/hamburgerMenuIcon.dc2adc4c8932fc5bd1cb28f5de760351.svg";
export { ForwardRef as ReactComponent };